/* eslint-disable */
export default {
  // 视频分类列表
  videoClassifyList: [{
    year: 2024, // 年份
    list: [{
      id: 18,
      title: '学习新修订《中国共产党纪律处分条例》'
    }, {
      id: 19,
      title: '习近平法治思想'
    }]
  }, {
    year: 2023, // 年份
    list: [{
      id: 16,
      title: '全面推进依法治国'
    }, {
      id: 17,
      title: '以高质量发展推进中国式现代化'
    }]
  }, {
    year: 2022, // 年份
    list: [{
      id: 14,
      title: '延安精神'
    }, {
      id: 15,
      title: '迎盛会'
    }]
  }, {
    year: 2021, // 年份
    list: [{
      id: 11,
      title: '朝鲜空战记忆'
    }, {
      id: 10,
      title: '红色平川'
    },
    {
      id: 13,
      title: '西征记'
    },
    {
      id: 12,
      title: '五十军朝鲜战记'
    },
    {
      id: 8,
      title: '陕甘风云'
    },
    {
      id: 9,
      title: '陕西抗战纪实'
    }]
  }, {
    year: 2020, // 年份
    list: [{
      id: 5,
      title: '重温党史重要会议精神'
    },
    {
      id: 6,
      title: '传承红色基因，弘扬红色精神'
    },
    {
      id: 7,
      title: '弘扬时代精神，凝聚前行力量'
    }
    ]
  }, {
    year: 2019,
    list: [{
      id: 1,
      title: '新时代面对面'
    },
    {
      id: 2,
      title: '新中国发展面对面'
    },
    {
      id: 3,
      title: '百年潮·中国梦'
    },
    {
      id: 4,
      title: '信仰的力量'
    }
    ]
  }],
  // 默认展示视频分类
  defaultClassify: {
    id: 18,
    title: '学习新修订《中国共产党纪律处分条例》'
  },
  defaultYear: 2024 // 默认展示信息的年份
}



// WEBPACK FOOTER //
// ./src/utils/const.js